import cashierService from 'modules/POS/services';
import { useAppDispatch } from 'store/hooks';
export const useCategoryActive = () => { };
const useCashierCategory = (): [string, (category_id: string) => void] => {
  const dispatch = useAppDispatch();
  const activeCateId = cashierService.selectors.activeCateId();

  const onChooseCategory = (category_id: string) => {
    dispatch(cashierService.actions.async.products.fetch(category_id));
  };

  return [activeCateId, onChooseCategory];
};

export default useCashierCategory;
